import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { token } = useParams();
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_URL || "https://phulhar-dham.onrender.com";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      return setError('पासवर्ड मेल नहीं खाते');
    }
    if (password.length < 6) {
      return setError('पासवर्ड कम से कम 6 अक्षरों का होना चाहिए');
    }

    setLoading(true);

    try {
      const response = await axios.put(`${API_BASE_URL}/api/auth/resetpassword/${token}`, {
        password
      });

      if (response.data.success) {
        setSuccess(true);
        // Auto-navigate to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'लिंक अमान्य या समाप्त हो गया है।');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-temple-bg flex items-center justify-center py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6 sm:space-y-8">
        <div className="text-center">
          <div className="text-4xl sm:text-6xl mb-4">🛡️</div>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-temple-text">
            नया पासवर्ड सेट करें
          </h2>
          <p className="mt-2 text-temple-text-muted text-sm sm:text-base">
            एक सुरक्षित नया पासवर्ड चुनें
          </p>
        </div>

        <div className="bg-temple-bg-warm rounded-3xl shadow-temple p-6 sm:p-8 border border-temple-primary/10">
          {success ? (
            <div className="text-center py-4">
              <div className="text-green-500 text-5xl mb-4">✅</div>
              <h3 className="text-xl font-bold text-temple-text mb-2">पासवर्ड सफलतापूर्वक बदला गया!</h3>
              <p className="text-temple-text-muted mb-6">आपको वापस लॉगिन पेज पर ले जाया जा रहा है...</p>
              <Link to="/login" className="btn-temple-primary px-6 py-2 rounded-lg inline-block">लॉगिन करें</Link>
            </div>
          ) : (
            <>
              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm mb-6 text-center font-bold">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-bold text-temple-text mb-2">
                    नया पासवर्ड
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="w-full p-3 border-2 border-temple-primary/20 rounded-lg focus:ring-0 focus:border-temple-primary transition bg-temple-bg"
                      required
                      placeholder="******"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-temple-text-muted"
                    >
                      <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-bold text-temple-text mb-2">
                    पासवर्ड की पुष्टि करें
                  </label>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="w-full p-3 border-2 border-temple-primary/20 rounded-lg focus:ring-0 focus:border-temple-primary transition bg-temple-bg"
                    required
                    placeholder="******"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full btn-temple-primary py-3 px-4 rounded-xl font-bold text-base sm:text-lg disabled:opacity-50"
                >
                  {loading ? 'अपडेट हो रहा है...' : 'पासवर्ड बदलें'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
